import React from 'react';
import MenuList from '../../components/menuList';

import './index.scss';

const menuData = [
	{
		name: 'Waxing',
		list: [
			{
				item: 'Eyebrow',
				price: '7',
			},
			{
				item: 'Lip',
				price: '6',
			},
			{
				item: 'Chin',
				price: '7',
			},
			{
				item: 'Under Arm',
				price: '10',
			},
			{
				item: 'Half Arm',
				price: '15',
			},
			{
				item: 'Full Arm',
				price: '20',
			},
			{
				item: 'Bikini',
				price: '15Up',
			},
			{
				item: 'Half Arm',
				price: '15',
			},
			{
				item: 'Half Leg',
				price: '20',
			},
			{
				item: 'Full Leg',
				price: '30',
			},
			{
				item: 'Back',
				price: '30Up',
			},
			{
				item: 'Chest',
				price: '30',
			},
			{
				item: 'Finger Toes',
				price: '5',
			},
			{
				item: 'Cheek',
				price: '10',
			},
		],
	},
	{
		name: 'Ear Candling',
		list: [
			{
				item: 'Ear Candling',
				price: '25',
				detail:
					'Ear Candling is a natural, non- intrusive procedure that may help alleviate the painful effects of chronic headaches or sinus conditions, ear infections, aller- gies or vertigo, as well as minor hearing loss due to excessive earwax build up.',
			},
			{
				item: 'Callus Eliminator',
				price: '8',
				detail:
					'With paraffin heel therapy Callus eliminator breaks down cal- lus in 3-5 minutes. It penetrates deep into the skin to soften and repair day, cracked and callused heels. Also the paraffin dip of your heels can help heal cracks faster by increasing blood flow and moistur-izing skin.',
			},
		],
	},
	{
		name: 'Nail Care',
		list: [
			{
				item: 'Polish Change',
				price: '8',
			},
			{
				item: 'French Manicure',
				price: '15',
			},
			{
				item: 'Paraffin',
				price: '5',
			},
			{
				item: 'Manicure',
				price: '10',
			},
			{
				item: 'Color Gel',
				price: '28',
			},
			{
				item: 'Cat Eyes Magnetic Gel',
				price: '33',
			},
			{
				item: 'French Color Gel',
				price: '33',
			},
			{
				item: 'Powder Gel',
				price: '38',
			},
			{
				item: 'Powder Gel + Tip',
				price: '48',
			},
			{
				item: 'French Powder Gel',
				price: '45',
			},
			{
				item: 'French Powder Gel + Tip',
				price: '55',
			},
			{
				item: 'Acrylic Fill Ins',
				price: '28',
			},
			{
				item: 'Fill w. Color Gel',
				price: '+15',
			},
			{
				item: 'Silk Tips Set',
				price: '50',
			},
			{
				item: 'Acrylic Full Set',
				price: '35Up',
			},
			{
				item: 'Acrylic Permanent French',
				price: '55',
			},
			{
				item: 'UV Gel Set',
				price: '60',
			},
			{
				item: 'Permanent French UV Gel',
				price: '70',
			},
			{
				item: 'UV Gel Fill',
				price: '38',
			},
			{
				item: 'Permanent French UV Gel Fill',
				price: '60',
			},
			{
				item: 'Manicure + Pedicure',
				price: '28',
			},
			{
				item: 'Luxury Spa Manicure',
				price: '30',
			},
		],
	},
	{
		name: 'Pedicure',
		list: [
			{
				item: 'Regular Pedicure',
				price: '20',
				detail: 'w. color Gel +$20',
			},
			{
				item: 'Aqua Flower Pedicure',
				price: '26',
				detail: '10 mins. massage with hot stone and aroma therapy lotion.',
			},
			{
				item: 'Aromatic Spa',
				price: '36',
				detail:
					'Turns an ordinary pedicure into an extraordinary spa experience smoothes and softens the skin as it replenishes nutrients and moisture 15 mins. Massage with special lotion.',
			},
			{
				item: 'Raspberry & Pomegranate',
				price: '45',
				detail:
					'20 mins. Pure mineral pomegranate silk powder. Raspberry scrub sweep away dead skin cells and clear con- gested pores. Raspberry mud firming all skin style. Pure pomegranate hot massage oil. Raspberry freshens and smooth lotions.',
			},
			{
				item: 'Olive Oil Garden Luxury Spa',
				price: '45',
				detail:
					'20 mins. Oliver oil garden mineral salt restores tried muscles. Olive oil garden exfoliation scrub smooth and dry flaky skin. Olive oil garden musk effect cleansing at the skin. Olive oil garden massage cream non greasy Smoothing. Olive oil garden skin booster leaves skin simply divine and moisture!',
			},
			{
				item: 'Green Tea Spa',
				price: '45',
				detail:
					'20 mins. Massage w. stone Zen-like style pedicure rehydrates and relaxes stressed-out skin. Green tea contains antioxidants promote anti- aging, using silk green tea soak moistur- izing cleansing cream aroma green tea scrub, green tea massage lotion.',
			},
			{
				item: 'Lemon Tree Spa',
				price: '45',
				detail:
					'20 mins. Massage w. stone Our perfect, light remedy to refresh dry, summer skin. we apply lemon-infused ingredients including lime great tea massage cream, and a light lemon tree oil extract for a sensory pedicure ideal for hot days.',
			},
			{
				item: 'Organic Mango Callus Spa',
				price: '45',
				detail:
					'Mango moisturizing natural powder, mango scrub quickly smooth skin, mango pure mud help reduce sign of aging, mango aromatic massage cream helps skin soften. Mango spa come with callus eliminator.',
			},
			{
				item: 'Luxury Spa',
				price: '60',
				detail:
					'All secret special powder, scrub mud, massage lotion, hand lotion come with 20 mins massage and extra 5 mins hand and arm massage and it also come with callus eliminator.',
			},
			{
				item: 'Blueberry Blast Spa',
				price: '55',
				detail:
					'30 mins. Massage w. stone and paraffin blueberry mineral powder also great as a soothing foot soak. This fresh blueberry puree is an exfoliating body scrub with fine earth exfoliates blueberry antioxidant mask. An excellent treatment for dry damaged dehydrated weathered skin. Blueberry lotion massage gel that helps promote a smooth & softer skin for all skin types.',
			},
			{
				item: 'Grapefruit Spa',
				price: '55',
				detail:
					'20 mins Massage w. stone Spa moisturizing grapefruit powder massage w. stone. Dream grapefruit scrub quickly brighten. Grapefruit mud mask moisture Skin and clean. Grapefruit massage cream relaxing the muscle. Grapefruit hand lotion and with free paraffin.',
			},
			{
				item: 'Cappuccino Spa',
				price: '55',
				detail:
					'Spa moisturizing cappuccino enjoying powder. Dream cappuccino scrub quickly relaxing. Cappuc- cino mud mask essential skin. Cappuccino massage cream helps skin smooth. Aroma cappuccino lotion come with free paraffin.',
			},
			{
				item: 'Well-Being Smoothie Spa',
				price: '55',
				detail:
					'30 mins. massage w. stone and paraffin pomegranate possesses natural estrogenic properties that can help revitalize your skin, pomegranate is also a natural anti-inflammatory that can help provide quick relief from minor skin irritations. Mandarin tangerine soak mandarin tangerine conditioning, aroma scrub, Mango conditional, aroma, moisturizing cleansing cream, pineapple mango, conditional, aroma masque.',
			},
			{
				item: 'Ultimate Relaxation Spa',
				price: '55',
				detail:
					'Deodorizing foot clean ultra mineral scrub exfolia-tion. Moisturizing mask wrap with warming ankle booties. 30 minutes massage with hydrating mas- sage cream and free paraffin. Your skin will be left with a radiant glow.',
			},
		],
	},
	{
		name: 'Special Package',
		list: [
			{
				item: 'Package 1',
				price: '40',
				detail: 'Pedicure & Manicure 15 Minutes Back or Foot Massage',
			},
			{
				item: 'Package 2',
				price: '60',
				detail:
					'Spa pedicure Paraffin, Massage & Manicure 20 Minutes Back Chair Massage',
			},
			{
				item: 'Package 3',
				price: '70',
				detail:
					'Aromatic Spa Pedicure, Color Gel Manicure & 10 Minutes Massage',
			},
			{
				item: 'Package 4',
				price: '85',
				detail: 'Eye Brow Pedicure & Manicure One Hour Hot Stone Massage',
			},
		],
	},
];

const ServicePage = () => {
	return (
		<div className='service-page'>
			<div>
				{menuData.map((v, i) => (
					<div className='menu-container' key={i}>
						<MenuList section={v.name} menuItems={v.list} />
					</div>
				))}
			</div>
		</div>
	);
};

export default ServicePage;
